/** @graphql cc **/

import gql from 'graphql-tag';

export const StarredContentMenuQuery = gql`
	query StarredContentMenuQuery($limit: Int = 30, $start: Int!) {
		favoriteContent(limit: $limit, start: $start) {
			nodes {
				id
				type
				subType
				title
				status
				space {
					id
					name
				}
				links {
					webui
					editui
				}
				metadata {
					currentuser {
						favourited {
							isFavourite
							favouritedDate
						}
						lastcontributed {
							status
							when
						}
					}
				}
				emoji: properties(keys: ["emoji-title-published", "emoji-title-draft"]) {
					nodes {
						id
						key
						value
					}
				}
			}
			pageInfo {
				hasNextPage
			}
			edges {
				cursor
			}
		}
	}
`;
